import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import {
  Card,
  CardHeader,
  Box
} from '@mui/material'

import MailboxList from '../organisms/MailboxList'
import MailDetailContent from '../organisms/MailDetailContent'

import { getUrlParamsObj } from '../../../services/urlServices'
import { getMessages } from '../../../services/B2BServices'

const Mailbox = () => {
  const { t } = useTranslation()
  const queryParams = getUrlParamsObj()

  const b2bCampaignId = queryParams?.b2bCampaignId

  const [messages, setMessages] = useState([])
  const [activeMessageDetail, setActiveMessageDetail] = useState(null)

  useEffect(() => {
    b2bCampaignId && getMessages({ b2bCampaignId }).then((res) => {
      setMessages(res.data)
    })
  }, [])

  return (
    b2bCampaignId
      ? <Card sx={{ height: 'auto' }}>
          <CardHeader title={t('mailTemplate.mailbox.inboxTitle')} className='pbe-4' />
          <Box
            position='relative'
            sx={{
              minHeight: activeMessageDetail ? 800 : 'unset'
            }}
          >
            {activeMessageDetail
              ? <MailDetailContent activeMessageDetail={activeMessageDetail} setActiveMessageDetail={setActiveMessageDetail}/>
              : <MailboxList tableData={messages} setActiveMessageDetail={setActiveMessageDetail}/>
            }
          </Box>
        </Card>
      : <div>{t('mailTemplate.mailbox.b2bCampaignIdError')}</div>
  )
}

export default Mailbox
